import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/HeroSection1';
import PromoSection from '../components/PromoSection';
import AboutSection from '../components/AboutUs';
import VideoLandingPage from '../components/Video/VideoLandingPage';
import FeatureSection from '../components/Features';
import Story from '../components/Story';
import DownloadSection from '../components/Download';
import PricingSection from '../components/Pricing';
import TeamMember from '../components/TeamMember';
import SubscribeSection from '../components/Subscribe';
import FooterSection from '../components/Footer';

const SITE_URL = 'https://exploroff.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ExplorOFF',
  url: SITE_URL,
  logo: { '@type': 'ImageObject', url: `${SITE_URL}/img/logo-color-1x.png` },
  description: 'Expert hiking guides, national park itineraries, and outdoor adventure planning for all skill levels.',
  sameAs: [
    'https://www.facebook.com/exploroff',
    'https://www.instagram.com/exploroff',
    'https://www.tiktok.com/@exploroff',
    'https://www.youtube.com/@exploroff',
  ],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'ExplorOFF',
  url: SITE_URL,
  description: 'Curated hiking guides, national park itineraries, and road trip routes across the US and Canada.',
  potentialAction: {
    '@type': 'SearchAction',
    target: { '@type': 'EntryPoint', urlTemplate: `${SITE_URL}/find-my-trip?location={search_term_string}` },
    'query-input': 'required name=search_term_string',
  },
};

const navSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'ExplorOFF Site Navigation',
  itemListElement: [
    { '@type': 'SiteNavigationElement', position: 1, name: 'Hiking Guides', url: `${SITE_URL}/hiking-guides` },
    { '@type': 'SiteNavigationElement', position: 2, name: 'Itineraries',   url: `${SITE_URL}/itineraries` },
    { '@type': 'SiteNavigationElement', position: 3, name: 'Find My Trip',  url: `${SITE_URL}/find-my-trip` },
    { '@type': 'SiteNavigationElement', position: 4, name: 'Submit Your Itinerary', url: `${SITE_URL}/submit-itinerary` },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'ExplorOFF – Hiking Guides, Road Trips & National Park Itineraries',
  url: SITE_URL,
  description: 'Discover expert hiking guides, national park itineraries, and road trip routes across the US and Canada.',
  inLanguage: 'en-US',
  isPartOf: { '@type': 'WebSite', url: SITE_URL },
  primaryImageOfPage: {
    '@type': 'ImageObject',
    url: `${SITE_URL}/img/chain-lakes-loop/chain-lakes-loop.webp`,
  },
};

class LandingPage extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>ExplorOFF – Hiking Guides, Road Trips &amp; National Park Itineraries</title>
          <meta name="description" content="Find expert hiking guides, curated national park itineraries, and road trip routes across the US and Canada. Use ExplorOFF's free trip finder to plan your perfect outdoor adventure." />
          <meta name="keywords" content="hiking guides, national park itineraries, road trips USA, outdoor adventure planner, Pacific Northwest hiking, Utah national parks, backpacking trips, trip finder, hiking trails, Yellowstone, Grand Canyon, Zion" />
          <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
          <meta name="author" content="ExplorOFF" />
          <meta name="theme-color" content="#004858" />
          <link rel="canonical" href="https://exploroff.com" />
          <link rel="alternate" hrefLang="en" href="https://exploroff.com" />

          {/* Open Graph */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://exploroff.com" />
          <meta property="og:site_name" content="ExplorOFF" />
          <meta property="og:title" content="ExplorOFF – Hiking Guides, Road Trips &amp; National Park Itineraries" />
          <meta property="og:description" content="Expert hiking guides, curated national park itineraries, and road trip routes across the US and Canada. Free outdoor trip planner." />
          <meta property="og:image" content="https://exploroff.com/img/chain-lakes-loop/chain-lakes-loop.webp" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content="Chain Lakes Loop trail with Mount Baker views – ExplorOFF" />
          <meta property="og:locale" content="en_US" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@exploroff" />
          <meta name="twitter:creator" content="@exploroff" />
          <meta name="twitter:title" content="ExplorOFF – Hiking Guides &amp; National Park Itineraries" />
          <meta name="twitter:description" content="Expert hiking guides, national park itineraries, and free road trip planning tools for every skill level." />
          <meta name="twitter:image" content="https://exploroff.com/img/chain-lakes-loop/chain-lakes-loop.webp" />
          <meta name="twitter:image:alt" content="Chain Lakes Loop hike – ExplorOFF" />

          {/* Structured data */}
          <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
          <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
          <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
          <script type="application/ld+json">{JSON.stringify(navSchema)}</script>
        </Helmet>
        <MessengerCustomerChat
          pageId="101590111335192"
          appId="695593052231950"
        />
        <Header />
        <div className="main">
          <HeroSection />
          <PromoSection />
          {/* <DownloadSection /> */}
          {/* <VideoLandingPage showDownloadBtn={true} /> */}
          {/* <Story /> */}
          {/* <PricingSection hideFaq={true} /> */}
          <TeamMember />
          {/* <FeatureSection /> */}
        </div>
        <SubscribeSection />
        <FooterSection />
      </>
    );
  }
}

export default LandingPage;
